/** A widget with nothing to show — switched-on widgets always render, empty or not. */
export function WidgetEmpty({ children }: { children: string }) {
  return (
    <div className="flex flex-1 items-center justify-center rounded-lg border border-dashed px-4 py-8 text-center">
      <p className="text-sm text-muted-foreground">{children}</p>
    </div>
  );
}
